import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";
import { api, eur, fileUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PayPalCheckout from "@/components/PayPalCheckout";
import { Loader } from "@/components/AuthGuards";

export default function ListingDetail() {
  const { id } = useParams();
  const { user } = useAuth();
  const [l, setL] = useState(null);
  const [img, setImg] = useState(0);
  const [err, setErr] = useState(false);

  const load = () => api.get(`/listings/${id}`).then(({ data }) => setL(data)).catch(() => setErr(true));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (err) return <p className="py-24 text-center text-neutral-500" data-testid="listing-not-found">Anzeige nicht gefunden.</p>;
  if (!l) return <Loader />;
  const own = user && user.user_id === l.seller_id;

  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8" data-testid="listing-detail-page">
      <Link to="/marktplatz" className="mb-8 inline-flex items-center gap-2 text-sm text-neutral-400 hover:text-white" data-testid="back-to-market"><ArrowLeft className="h-4 w-4" /> Marktplatz</Link>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2">
        <div>
          <div className="surface aspect-[4/5] overflow-hidden"><img src={fileUrl(l.image_paths[img])} alt={l.title} className="h-full w-full object-cover" data-testid="listing-main-image" /></div>
          {l.image_paths.length > 1 && (
            <div className="mt-3 flex gap-2">{l.image_paths.map((p, i) => <button key={p} onClick={() => setImg(i)} className={`h-20 w-16 overflow-hidden rounded-lg border ${i === img ? "border-[#D4AF37]" : "border-white/10"}`}><img src={fileUrl(p)} alt="" className="h-full w-full object-cover" /></button>)}</div>
          )}
        </div>
        <div>
          <p className="label-over">{l.brand || "Ohne Marke"} · {l.category}</p>
          <h1 className="mt-3 font-serif text-4xl leading-tight" data-testid="listing-title">{l.title}</h1>
          <p className="mt-4 text-3xl font-semibold" data-testid="listing-price">{eur(l.price)}</p>
          <dl className="mt-8 grid grid-cols-2 gap-4 text-sm">
            {[["Größe", l.size || "–"], ["Zustand", l.condition], ["Verkäufer:in", l.seller_name], ["Kategorie", l.category]].map(([k, v]) => (
              <div key={k} className="surface p-4"><dt className="text-[10px] uppercase tracking-widest text-neutral-500">{k}</dt><dd className="mt-1">{v}</dd></div>
            ))}
          </dl>
          {l.description && <p className="mt-6 whitespace-pre-line text-sm leading-relaxed text-neutral-400">{l.description}</p>}
          <div className="mt-8 space-y-4">
            {l.status === "sold" ? <p className="surface p-4 text-center font-serif text-xl" data-testid="listing-sold">Dieser Artikel wurde verkauft.</p>
              : own ? <p className="surface p-4 text-sm text-neutral-400" data-testid="listing-own-note">Das ist deine Anzeige. Du erhältst {eur(l.seller_payout)} (abzgl. {eur(l.commission)} vyne-Provision).</p>
              : !user ? <Link to="/login" state={{ from: `/marktplatz/${l.id}` }} className="btn-cream w-full" data-testid="listing-login-to-buy">Anmelden zum Kaufen</Link>
              : <PayPalCheckout listingId={l.id} onPaid={load} />}
            <p className="flex items-center gap-2 text-xs text-neutral-500"><ShieldCheck className="h-4 w-4 text-[#D4AF37]" /> Sichere Zahlung über PayPal mit Käuferschutz.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
